import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import AppNav from '../components/AppNav.vue'
import Home from '../views/Home.vue'
import ApiKey from '../views/ApiKey.vue'
import UserInfo from '../views/UserInfo.vue'
import CardGen from '../views/CardGen.vue'
import ApiLog from '../views/ApiLog.vue'
import CardManage from '../views/CardManage.vue'
import UserManage from '../views/UserManage.vue'
import AdminApiKeyManage from '../views/AdminApiKeyManage.vue'
import AdminApiLogManage from '../views/AdminApiLogManage.vue'

Vue.use(Router)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/',
    component: AppNav,
    meta: { requiresAuth: true },
    children: [
      { path: '', name: 'Home', component: Home },
      { path: 'manageApiKey', name: 'ApiKey', component: ApiKey },
      { path: 'userInfo', name: 'UserInfo', component: UserInfo },
      { path: 'cardGen', name: 'CardGen', component: CardGen },
      { path: 'cardManage', name: 'CardManage', component: CardManage, meta: { requiresAdmin: true } },
      { path: 'userManage', name: 'UserManage', component: UserManage, meta: { requiresAdmin: true } },
      { path: 'adminApiKeyManage', name: 'AdminApiKeyManage', component: AdminApiKeyManage, meta: { requiresAdmin: true } },
      { path: 'adminApiLogManage', name: 'AdminApiLogManage', component: AdminApiLogManage, meta: { requiresAdmin: true } }
    ]
  }
]

const router = new Router({
  mode: 'history',
  routes
})

// 路由守卫：未登录跳转到 /login
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (to.matched.some(r => r.meta.requiresAuth)) {
    if (!token) {
      next({ path: '/login', query: { redirect: to.fullPath } });
    } else {
      next();
    }
  } else {
    next();
  }
})

export default router; 